import type { FC, ReactNode } from 'react'
import type { TagIndexPageProps } from '@/lib/tag-pages'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { tagIndexProps } from '@/lib/tag-pages'
import TagIndexView from '@/components/kb/tag-index-view'

const GoalsIndex: FC<TagIndexPageProps> = ({ kind, tags, unavailable }): ReactNode => {
    return (
        <Layout>
            <Seo title='Goals and problems' description="Start from what you want to achieve or fix: wealth, business growth, health, marriage, education, protection from negative energy and more." />

            <TagIndexView
                kind={kind}
                tags={tags}
                unavailable={unavailable}
                title='Goals and Problems'
                hindi='लक्ष्य और समस्याएं'
                description="Start from what you want to achieve or fix: wealth, business growth, health, marriage, education, protection from negative energy and more."
            />
        </Layout>
    )
}

export const getServerSideProps = tagIndexProps('goal')

export default GoalsIndex
